module.exports = __webpack_public_path__ + "static/favicon-8026f52c40cb4f1711502c9259079909.ico";